// extracted by mini-css-extract-plugin
module.exports = {"fontPrimary":"'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif","primary":"rgb(40, 90, 132)","banner":"r_5","img":"r_bm","text":"r_bn"};